import { BulkSelectionScope } from '../models/catalog-plan.model';

/**
 * Le bloc affiche fait-il partie de la selection en masse gelee ?
 *
 * - pas de selection (`scope` nul) => non, il n'y a rien a peindre ;
 * - `scope.blockId` nul (selection prise en vue top) => la selection est plan-wide, les places
 *   filtrees de n'importe quel bloc en font partie ;
 * - `scope.blockId` renseigne => uniquement ce bloc.
 *
 * Garde-fou de la surbrillance du canvas : sans lui, `CatalogPlanBlockViewService` peignait comme
 * selectionnees les places filtrees de CHAQUE bloc visite. L'application du filtre a l'entree d'un
 * bloc suffisait a declencher la surbrillance, puisque le service est un singleton dont le drapeau
 * « une selection existe » traverse la navigation. L'utilisateur voyait donc des places « selectionnees »
 * qui n'appartenaient pas a sa selection, et en nombre different de celui annonce par le compteur.
 */
export function isBlockInBulkSelectionScope(
  scope: BulkSelectionScope | null | undefined,
  blockId: number | null | undefined,
): boolean {
  if (!scope) {
    return false;
  }
  return scope.blockId == null || scope.blockId === blockId;
}
